// All content for the PhotonPE landing page (frontend-only mock data)

export const contact = {
  email: "info@photonpe.com",
  phone: "+91 9311914818",
  phoneRaw: "+919311914818",
};

export const company = {
  brand: "PhotonPE",
  legalName: "Lumous Infotech Private Limited",
  offices: [
    { label: "Noida Office", address: "3rd Floor, B-53, Sector 64, Noida, Gautam Buddha Nagar, Uttar Pradesh – 201301" },
    { label: "Mumbai Office", address: "Unit No. 1007, Ekatva Onyx, Plot No. A-280, Wagle Estate, Thane, Maharashtra" },
  ],
};

export const navItems = [
  { label: "About Us", href: "#about" },
  { label: "Industries", href: "#industries" },
  {
    label: "Products & Solutions",
    href: "#services",
    children: [
      { label: "BBPS Solutions", href: "/services/bbps-solutions" },
      { label: "POS Solutions", href: "/services/pos-solutions" },
      { label: "FasTag Solutions", href: "/services/fastag-solutions" },
      { label: "Photon Collect", href: "/services/photon-collect" },
      { label: "Photon Disburse", href: "/services/photon-disburse" },
      { label: "Photon Treasury", href: "/services/photon-treasury" },
      { label: "Photon Edu ERP", href: "/services/photon-edu-erp" },
      { label: "Photon HRMS", href: "/services/photon-hrms" },
      { label: "Cash Pickup & Deposit", href: "/services/cash-pickup-deposit" },
      { label: "Photon Verify", href: "/services/photon-verify" },
    ],
  },
  { label: "Blog", href: "#blog" },
  { label: "Contact Us", href: "#cta" },
  {
    label: "Policies",
    href: "#footer",
    children: [
      { label: "Privacy Policy", href: "/policies/privacy-policy" },
      { label: "Terms & Conditions", href: "/policies/terms-and-conditions" },
      { label: "Refund Policy", href: "/policies/refund-policy" },
      { label: "Grievance Policy", href: "/policies/grievance-policy" },
    ],
  },
];

export const heroSlides = [
  { img: "bill", name: "BBPS", kicker: "Bharat Bill Payments", title: "Every Bill. One Counter.", desc: "Electricity, gas, water, DTH and 20,000+ billers through a single BBPS-powered retail counter.", cta: "Explore BBPS", href: "/services/bbps-solutions" },
  { img: "pos", name: "POS", kicker: "Point of Sale", title: "Smart POS for Every Shop", desc: "Accept cards, UPI and tap-to-pay on robust Android terminals with instant settlement to your wallet.", cta: "Explore POS", href: "/services/pos-solutions" },
  { img: "fastag", name: "FASTag", kicker: "FASTag Solutions", title: "Issue & Recharge FASTag Instantly", desc: "Corporate fleets and walk-in customers — issue, recharge and track FASTags from one dashboard.", cta: "Explore FASTag", href: "/services/fastag-solutions" },
  { img: "qr", name: "Collect", kicker: "Photon Collect", title: "Collect Payments with One QR", desc: "UPI QR, soundbox alerts and payment links with real-time reconciliation for every rupee collected.", cta: "Explore Collect", href: "/services/photon-collect" },
  { img: "disburse", name: "Disburse", kicker: "Photon Disburse", title: "Instant Payouts. Every Rupee, On Time.", desc: "IMPS, NEFT and UPI bulk disbursals with live status, auto-refunds and a full audit trail.", cta: "Explore Payouts", href: "/services/photon-disburse" },
  { img: "wallet", name: "Treasury", kicker: "Photon Treasury", title: "One Wallet for Your Whole Network", desc: "Load funds to agents, distributors and teams, then track every spend in a fully auditable treasury.", cta: "Explore Treasury", href: "/services/photon-treasury" },
  { img: "cash", name: "Cash Pickup", kicker: "Cash Pickup & Deposit", title: "Doorstep Cash Pickup for Retailers", desc: "Schedule a pickup, track the agent and get the amount credited straight to your PhotonPE wallet.", cta: "See How", href: "/services/cash-pickup-deposit" },
  { img: "erp", name: "ERP & HRMS", kicker: "Business Solutions", title: "Run Your School & Team Digitally", desc: "Edu ERP and HRMS bring fees, attendance, payroll and records together in one secure platform.", cta: "Explore Solutions", href: "/services/photon-edu-erp" },
  { img: "shield", name: "Verify", kicker: "Photon Verify", title: "KYC & Verification in Seconds", desc: "PAN, Aadhaar, bank account and GST verification APIs that keep your network compliant and safe.", cta: "Explore Verify", href: "/services/photon-verify" },
];

export const about = {
  tag: "About us",
  image1: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  image2: "https://images.pexels.com/photos/7988663/pexels-photo-7988663.jpeg?auto=compress&cs=tinysrgb&w=940",
  titleLead: "We build the digital ",
  titleHi: "foundation businesses depend on.",
  body: "PhotonPE is a digital infrastructure company that helps businesses operate with greater clarity, speed, and confidence. We work across industries to design and deliver systems that handle the complex, behind-the-scenes work that keeps organizations running — from financial processes to day-to-day operations.",
};

export const developerApi = {
  tag: "Fast, Reliable & Developer-Friendly APIs",
  title: "Developer-First API",
  titleHi: "Infrastructure",
  body: "Build faster with secure, scalable, and developer-friendly infrastructure designed for modern financial operations and business workflows.",
  code: [
    "// PhotonPE Collection API",
    "curl -X POST https://api.photonpe.com/v1/collect \\",
    "  -H 'Authorization: Bearer $PP_KEY' \\",
    "  -d '{ \"amount\": 2999, \"vpa\": \"user@upi\" }'",
    "",
    "{ \"status\": \"success\",",
    "  \"txn_id\": \"PP8492X\",",
    "  \"settled\": true }",
  ],
};

// Sidebar categories for the services showcase
export const serviceCategories = [
  {
    group: "Financial Technology",
    items: ["BBPS Solutions", "POS Solutions", "FasTag Solutions"],
  },
  {
    group: "Payment Technology",
    items: ["Photon Collect", "Photon Disburse", "Photon VaultPay"],
  },
  {
    group: "Business solutions",
    items: ["Photon Edu ERP", "Photon WorkDesk", "Photon HireOrbit"],
  },
  {
    group: "Security & Compliance",
    items: ["Photon Shield"],
  },
];

// Product showcase sections (each renders a themed mock UI)
export const products = [
  {
    id: "bbps",
    kicker: "INTEGRATE • PAY • SCALE",
    title: "Bharat Bill",
    titleAccent: "Payment",
    titleTail: "Platform",
    desc: "Expand your fintech offerings with India's most trusted utility network. PhotonPE gives you instant access to 20,000+ billers across electricity, gas, water, telecom, loan EMIs, and more — all through a single, powerful API.",
    highlights: [
      { title: "20,000+ Billers", sub: "Access all major utility providers instantly." },
      { title: "Single API", sub: "Unified integration for all categories." },
    ],
    cta: "Explore Now",
    chips: [
      { title: "Electricity", sub: "Pan-India Boards" },
      { title: "Telecom", sub: "Prepaid & Postpaid" },
      { title: "Water", sub: "Municipal Transit" },
    ],
    visual: "bbps",
    theme: "light",
  },
  {
    id: "pos",
    kicker: "DEPLOY • MANAGE • SCALE",
    title: "Point of",
    titleAccent: "Sale",
    titleTail: "Solutions",
    desc: "Empower your merchant network with PhotonPE's end-to-end POS solutions. Robust hardware terminal-based POS gives your fintech the infrastructure to deploy, manage, and scale merchant payments — all under one platform.",
    highlights: [
      { title: "Hardware", sub: "Terminals POS both supported." },
      { title: "Unified Platform", sub: "Manage all your merchants centrally." },
    ],
    cta: "Explore Now",
    chips: [
      { title: "Multi-mode", sub: "Card, UPI, Wallet" },
      { title: "Instant Setups", sub: "Fast & Reliable" },
      { title: "PCI-DSS", sub: "Secure Transactions" },
    ],
    visual: "pos",
    theme: "light",
  },
  {
    id: "fastag",
    kicker: "TRACK • TOLL • SCALE",
    title: "Corporate",
    titleAccent: "FASTag",
    titleTail: "Platform",
    desc: "Managing a corporate fleet involves more than just vehicles. PhotonPE's FASTag solution brings together toll management, live tracking, and automated ledger sync into one unified platform.",
    highlights: [
      { title: "End-to-End Automation", sub: "Eliminate manual processes instantly." },
      { title: "Centralized Dashboard", sub: "Monitor all metrics in one single view." },
    ],
    cta: "Explore Now",
    chips: [
      { title: "Toll Collection", sub: "Automated & Secure" },
      { title: "Fleet Tracking", sub: "Vehicle & Route Tracking" },
      { title: "Wallet & Ledger", sub: "Effortless Management" },
    ],
    visual: "fastag",
    theme: "light",
  },
  {
    id: "collect",
    kicker: "RECEIVE • RECONCILE • GROW",
    title: "Photon",
    titleAccent: "Collect",
    titleTail: "PayIn Solutions",
    desc: "Every business deserves a payment experience that just works. With PhotonPE's PayIn solution, merchants receive payments via UPI, cards, net banking, and more — quickly, securely, and without any friction. Funds are credited directly to your account.",
    highlights: [
      { title: "Multi-mode Payments", sub: "Accept UPI, Cards & Net Banking." },
      { title: "Instant Settlements", sub: "Fast credits direct to your bank." },
    ],
    cta: "Explore PayIn",
    chips: [
      { title: "Smart Routing", sub: "High Success Rates" },
      { title: "Secure Checkout", sub: "PCI-DSS Compliant" },
      { title: "Easy Integration", sub: "Developer APIs" },
    ],
    visual: "collect",
    theme: "light",
  },
  {
    id: "disburse",
    kicker: "SEND • SETTLE • RECONCILE",
    title: "Payout",
    titleAccent: "Infrastructure",
    titleTail: "",
    desc: "Photon Disburse is PhotonPE's payout infrastructure designed to simplify and automate outbound payments. Whether paying vendors, settling commissions, or processing refunds, it enables secure, real-time transfers via IMPS, NEFT and RTGS.",
    highlights: [
      { title: "Instant Routing", sub: "Smart IMPS, NEFT & RTGS selection." },
      { title: "Bulk Disbursements", sub: "Pay vendors & agents simultaneously." },
    ],
    cta: "Explore Payouts",
    chips: [
      { title: "24/7 Transfers", sub: "No Banking Holidays" },
      { title: "API Driven", sub: "Automate via Code" },
      { title: "Reconciliations", sub: "Instant Webhook Sync" },
    ],
    visual: "disburse",
    theme: "light",
  },
  {
    id: "vaultpay",
    kicker: "LOAD • SPEND • TRACK",
    title: "Photon",
    titleAccent: "VaultPay",
    titleTail: "",
    desc: "Photon VaultPay is a powerful internal wallet system for businesses, enterprises, and fintech networks. Admins load funds into any user's wallet — agent, distributor, or team member. Users spend, upload invoices, and track every transaction in a fully auditable platform.",
    highlights: [
      { title: "Instant Funding", sub: "Admins can load balances in seconds." },
      { title: "Invoice Uploads", sub: "Users attach receipts to every spend." },
    ],
    cta: "Explore Now",
    chips: [
      { title: "B2B Wallets", sub: "Distributors & Agents" },
      { title: "Invoice Sync", sub: "Attach Bills Easily" },
      { title: "Audit Trail", sub: "100% Transparent" },
    ],
    visual: "vaultpay",
    theme: "light",
  },
  {
    id: "eduerp",
    kicker: "ADMINISTER • AUTOMATE • EDUCATE",
    title: "Education",
    titleAccent: "ERP",
    titleTail: "Platform",
    desc: "Managing an educational institution involves more than just classrooms. PhotonPE's ERP brings together fee management, student records, attendance, HR, and more — into one unified platform for schools, colleges, and universities.",
    highlights: [
      { title: "End-to-End Automation", sub: "Eliminate manual processes instantly." },
      { title: "Centralized Dashboard", sub: "Monitor all metrics in one single view." },
    ],
    cta: "Explore Now",
    chips: [
      { title: "Fee Collection", sub: "Automated & Secure" },
      { title: "Attendance", sub: "Staff & Student Tracking" },
      { title: "HR & Payroll", sub: "Effortless Management" },
    ],
    visual: "eduerp",
    theme: "light",
  },
  {
    id: "hrms",
    kicker: "ONBOARD • MANAGE • PAYROLL",
    title: "HR",
    titleAccent: "Management",
    titleTail: "System",
    desc: "Your workforce is your most valuable asset. PhotonPE's HRMS gives enterprises a unified platform to manage the complete employee lifecycle — from onboarding to exit. Automate HR operations and empower teams to perform at their best.",
    highlights: [
      { title: "Complete Lifecycle", sub: "From hiring to full-and-final settlement." },
      { title: "Automated Payroll", sub: "1-click bulk salary disbursements." },
    ],
    cta: "Explore HRMS",
    chips: [
      { title: "Payroll", sub: "Automated Salary Configs" },
      { title: "Attendance", sub: "Leave & Shift Tracking" },
      { title: "Compliance", sub: "PF, PT, ESI & TDS" },
    ],
    visual: "hrms",
    theme: "light",
  },
  {
    id: "verify",
    kicker: "VERIFY • ONBOARD • SCALE",
    title: "Identity",
    titleAccent: "Verification",
    titleTail: "API System",
    desc: "PhotonVerify makes it easy for businesses to verify identity and business details through simple APIs. It speeds up onboarding and reduces manual verification work, with plug-and-play REST APIs that provide quick, reliable responses.",
    highlights: [
      { title: "Instant KYC", sub: "Verify Aadhaar, PAN & IDs in seconds." },
      { title: "Easy Integration", sub: "Plug and play REST APIs for developers." },
    ],
    cta: "Explore API Docs",
    chips: [
      { title: "Business KYC", sub: "GSTIN & MCA Verifications" },
      { title: "Identity APIs", sub: "Aadhaar, PAN & Voter ID" },
      { title: "Bank Verification", sub: "Penny Drop & Name Match" },
    ],
    visual: "verify",
    theme: "light",
  },
];

export const partners = [
  "SecurePay", "TrustBank", "NexaPay", "OmniGate", "PayBridge",
  "FinCore", "SwiftSettle", "UnityPSP",
];

export const whyChoose = {
  image1: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxkaWdpdGFsJTIwcGF5bWVudHxlbnwwfHx8fDE3ODczMDc5MTR8MA&ixlib=rb-4.1.0&q=85",
  image2: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMHRlYW18ZW58MHx8fHwxNzg3MzA3OTE0fDA&ixlib=rb-4.1.0&q=85",
  stat: "10+",
  statLabel: "Years of Team Leadership",
  items: [
    { icon: "Percent", title: "Best Commission Rates", desc: "Earn more on every transaction—be it BBPS or beyond." },
    { icon: "Code2", title: "API-First Architecture", desc: "Frictionless integration for developers. SDKs, sandbox access and webhook-ready APIs." },
    { icon: "ShieldCheck", title: "Secure by Design", desc: "Regulatory-compliant and PCI-DSS aligned, with 99.9% uptime and data encryption." },
    { icon: "Handshake", title: "Partner-Centric Model", desc: "We scale with you—offering white-labelled dashboards, channel support and documentation." },
  ],
};

export const industries = [
  { icon: "ShoppingCart", label: "E-Commerce" },
  { icon: "GraduationCap", label: "Educational Institutions" },
  { icon: "Landmark", label: "Financial Services" },
  { icon: "Hotel", label: "Hospitality" },
  { icon: "ShieldCheck", label: "Insurance" },
  { icon: "Building2", label: "NBFC" },
  { icon: "Rocket", label: "Startup" },
  { icon: "Plane", label: "Travel" },
];

export const onboarding = [
  { n: "01", title: "Create Account", desc: "Sign up quickly to get started", time: "In 2 Minutes" },
  { n: "02", title: "Change Password", desc: "Set a secure password for your account", time: "In 1 Minute" },
  { n: "03", title: "Complete KYC", desc: "Submit your basic details for verification", time: "In 30 Minutes" },
  { n: "04", title: "Sign eAgreement", desc: "Review and digitally sign the agreement", time: "In 2 Minutes" },
  { n: "05", title: "API Integration", desc: "Connect our APIs with your platform", time: "Easy Integration" },
  { n: "06", title: "Start Transactions", desc: "Start using the platform", time: "Within Minutes" },
];

export const faqs = [
  {
    q: "What is PhotonPE?",
    a: "PhotonPE is a technology-driven fintech platform delivering secure, scalable, and revenue-generating digital financial infrastructure across India, empowering partners to provide reliable financial and operational services through a unified technology platform.",
  },
  {
    q: "What services does PhotonPE offer to businesses?",
    a: "PhotonPE offers services like bill payments, POS solutions, payout systems, payment collection, ERP, HRMS, and verification tools.",
  },
  {
    q: "How does merchant onboarding work and what are the requirements?",
    a: "Onboarding is quick and hassle-free—simply submit your details, complete the KYC process, upload the required documents, and your account will be activated shortly.",
  },
  {
    q: "Which payment methods does PhotonPE support?",
    a: "PhotonPE supports UPI, debit & credit cards, net banking, wallets, QR code payments, and payment links, enabling fast and seamless transactions across all major digital channels.",
  },
  {
    q: "What industries do you serve?",
    a: "We power utility fintech across E-commerce & Startups, NBFCs & Financial Institutions, Travel & Hospitality, Education & Institutions, and Insurance & CSP/e-Governance.",
  },
  {
    q: "Is PhotonPE secure for my transactions?",
    a: "Yes. Security is our top priority. We ensure bank-grade security with data encryption and fraud protection, and are fully compliant with RBI guidelines and industry standards, ensuring safe and reliable transactions.",
  },
];

export const faqImage = "https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80";
export const ctaImage = "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80";

export const blogPosts = [
  {
    image: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?crop=entropy&cs=srgb&fm=jpg&w=1000&q=80",
    title: "From Paper to Portal: How Digital Fee Collection is Reshaping Indian Education",
  },
  {
    image: "https://images.unsplash.com/photo-1556742031-c6961e8560b0?crop=entropy&cs=srgb&fm=jpg&w=1000&q=80",
    title: "College Payments, Simplified: The Rise of Digital Fee Systems Across Campuses",
  },
  {
    image: "https://images.unsplash.com/photo-1599050751795-6cdaafbc2319?crop=entropy&cs=srgb&fm=jpg&w=1000&q=80",
    title: "School Fee Payments in India: Why Going Digital Just Makes Sense",
  },
];

export const certifications = [
  { icon: "ShieldCheck", label: "PCI-DSS Aligned" },
  { icon: "Lock", label: "256-bit Encryption" },
  { icon: "BadgeCheck", label: "ISO 27001 Practices" },
  { icon: "Landmark", label: "RBI Guidelines Aligned" },
];

export const footer = {
  about:
    "PhotonPE is a technology-driven fintech platform delivering secure, scalable digital financial infrastructure across India — your apka apna banking partner.",
  columns: [
    {
      title: "Company",
      links: ["About Us", "Industries", "Blog", "Contact Us", "Careers"],
    },
    {
      title: "Solutions",
      links: ["BBPS Solutions", "POS Solutions", "FasTag", "Photon Collect", "Photon Disburse"],
    },
    {
      title: "Policies",
      links: ["Privacy Policy", "Terms & Conditions", "Refund Policy", "Grievance Policy"],
    },
  ],
  socials: ["Linkedin", "Facebook", "Instagram", "Twitter"],
};
